export enum ErrorModalCta {
  RELOAD = 'reload',
  BACK = 'back',
  SIGN_UP = 'signUp'
}
